var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Modal, ModalOverlay, ModalContent, ModalHeader, ModalCloseButton, Button, Flex, Text, ModalBody, ModalFooter, } from 'shared/components/ui';
import { CountdownTimer } from '../countdownTimer';
import { Close } from 'shared/assets/icons';
import { MODAL_MESSAGE_NOTES } from '../constants';
export var AutoLogoutModal = function (_a) {
    var title = _a.title, isOpen = _a.isOpen, onClose = _a.onClose, signOut = _a.signOut, primaryButton = _a.primaryButton, children = _a.children;
    return (_jsxs(Modal, __assign({ variant: "confirm", id: "auto-logout-modal", isOpen: isOpen, onClose: onClose, closeOnOverlayClick: false, size: "md", isCentered: true }, { children: [_jsx(ModalOverlay, {}), _jsxs(ModalContent, { children: [_jsxs(ModalHeader, { children: [title, _jsx(ModalCloseButton, { as: Close })] }), _jsx(ModalBody, { children: _jsxs(Flex, __assign({ flexDirection: "column", gap: 3 }, { children: [children, _jsx(Text, { children: MODAL_MESSAGE_NOTES })] })) }), _jsxs(ModalFooter, { children: [_jsx(Button, __assign({ "data-testid": "auto-logout-button", variant: "outline", onClick: signOut }, { children: "Sign Out" })), primaryButton] })] })] })));
};
export var LogoutTime = function (_a) {
    var finishTimeMessage = _a.finishTimeMessage, initialTime = _a.initialTime;
    return (_jsxs(_Fragment, { children: [_jsx(Text, __assign({ size: "subtitle" }, { children: finishTimeMessage })), _jsx(Text, __assign({ size: "subtitle" }, { children: _jsx(CountdownTimer, { initialTime: Math.round(initialTime / 1000) }) }))] }));
};
